<div class="seal-history">
    <div *ngIf="!sealHistory.length">{{ 'aumico_annual_report_print_page_no_seal_history' | i18next }}</div>
    <div *ngFor="let event of sealHistory" class="event">
        <div class="status">
            <span [ngClass]="event.action">
                {{
                    event.action === AnnualReportAction.SEAL
                        ? ('aumico_annual_report_seal' | i18next)
                        : ('aumico_annual_report_unseal' | i18next)
                }}
            </span>
            <span
                class="date"
                *ngIf="event.action === AnnualReportAction.UNSEAL"
                hamBadge
                color="yellow"
                size="large"
                [hasCancelIcon]="false"
                icon="assets/hamIcons/clock-fill.svg"
            >
                {{ event.createdAt | dateTimeLocale }}
            </span>
            <span
                class="date"
                *ngIf="event.action === AnnualReportAction.SEAL"
                hamBadge
                color="primary"
                size="large"
                [hasCancelIcon]="false"
            >
                {{ event.createdAt | dateTimeLocale }}
            </span>
        </div>
        <div class="user">
            <ham-avatar type="circle" size="regular" [fullName]="event.userName"></ham-avatar>
            <span>{{ event.userName }}</span>
        </div>
        <hr />
    </div>
</div>
